import { connect } from 'react-redux';

// lib imports
import deepEqual from 'fast-deep-equal';
import FoldedNavigation from '../components/FoldedNavigation';

// local imports
import { setBrowseShopNavCategoryIds } from '../actions/navigation';

const NAV_DEBOUNCE_DELAY = 500;
const GROCERY_CATEGORY_ID = 'grocery';
const TOP_PICKS_CATEGORY_ID = 'highlighted';

const getAllOtherLevels = (categoriesTree, ids) => {
  const levels = [];
  for (let i = 0, len = ids.length; i < len; i++) {
    let branch = { children: categoriesTree[GROCERY_CATEGORY_ID] };
    if (ids[0] === TOP_PICKS_CATEGORY_ID) {
      branch = { children: categoriesTree[TOP_PICKS_CATEGORY_ID] };
      // skip TOP_PICKS_CATEGORY_ID - it was already added
      if (i === 0) {
        continue; // eslint-disable-line no-continue
      }
    }
    const catArr = ids.slice(0, i + 1);
    for (let j = 0, jlen = catArr.length; j < jlen; j++) {
      if (branch && branch.children) {
        const nested = branch.children.find(item => item.id === catArr[j]);
        if (nested) { branch = nested; }
      }
    }
    if (branch && branch.children) {
      levels.push({
        id: branch.id,
        name: branch.name,
        categories: branch.children,
      });
    }
  }
  return levels;
};

const getLevels = (categoriesTree, ids) => {
  // level 0 is always visible
  let levels = [{
    id: null,
    name: null,
    categories: categoriesTree[GROCERY_CATEGORY_ID],
  }];

  // if no category is selected, show items from TOP_PICKS_CATEGORY_ID category
  if (!ids || !ids.length || ids[0] === TOP_PICKS_CATEGORY_ID) {
    levels.push({
      id: TOP_PICKS_CATEGORY_ID,
      name: null,
      categories: categoriesTree.highlighted,
    });
    // if there is only one category and it's
    // TOP_PICKS_CATEGORY_ID then we have all we need
    if (ids.length <= 1 && ids[0] === TOP_PICKS_CATEGORY_ID) {
      return levels;
    }
  }

  const otherLevels = getAllOtherLevels(categoriesTree, ids);
  if (otherLevels) {
    levels = levels.concat(otherLevels);
  }

  return levels;
};

const getActions = (dispatch, ownProps) => {
  let to;

  function itemMouseOverAction(e, categoryIds) {
    e.stopPropagation();
    clearTimeout(to);
    // filter out unintentional mouseover events
    to = setTimeout(() => {
      dispatch(setBrowseShopNavCategoryIds(categoryIds));
    }, NAV_DEBOUNCE_DELAY);
  }

  function itemMouseOutAction(e) {
    e.stopPropagation();
    clearTimeout(to);
  }

  function levelMouseOverAction() {
    clearTimeout(to);
  }

  function itemTouchStartAction(e, prevCatIds, nextCatIds, catId) {
    if (nextCatIds[nextCatIds.length - 1] !== catId) {
      nextCatIds.push(catId);
    } else if (!deepEqual(prevCatIds, nextCatIds)) {
      e.preventDefault();
    }
  }

  function navMouseLeaveAction() {
    const { collapse } = ownProps;
    clearTimeout(to);
    if (typeof collapse === 'function') {
      // manually trigger browse shop dropdown mouseleave handler
      // as a workaround for strange React behaviour (not triggering mouseleave
      // for last level of dropdown)
      collapse();
    }
    dispatch(setBrowseShopNavCategoryIds([]));
  }

  return {
    itemMouseOverAction,
    itemMouseOutAction,
    levelMouseOverAction,
    itemTouchStartAction,
    navMouseLeaveAction,
  };
};

export default connect(
  (state) => ({
    user: state.user,
    promos: state.navigation.promos,
    levelIds: state.navigation.browseShopNavCategoryIds,
    levels: getLevels(state.topNavigation.categories, state.navigation.browseShopNavCategoryIds),
    brandBanners: state.topNavigation.brandBanners,
    brandBannersWideThreshold: state.properties.brandShopsWideLayoutThreshold || 0,
    defaultBrandBannersActive: true,
    lastEventType: state.navigation.lastEventType,
    pageParameters: { hiddenOOS: state.user.betaFeatures.includes('HIDE_OOS_ITEMS') ? true : undefined },
  }),
  getActions,
)(FoldedNavigation);
